import { useAtomValue } from 'jotai';
import { FC } from 'react';
import { $CurrentArticleRelatedExperience } from '../../atoms/current-article-related-experience';
import { useTranslation } from 'react-i18next';
import './style.scss';

export const RelatedExperience: FC<{ articleRegion: string }> = ({ articleRegion }) => {
  const relatedExperience = useAtomValue($CurrentArticleRelatedExperience);
  const { t } = useTranslation();

  return (
    relatedExperience.answerReferralQuery.length > 0 && (
      <div className="related-experience-module">
        <div className="related-experience-title">{t('seo_v4_postRecommendation_title')}</div>
        <ul>
          {relatedExperience.answerReferralQuery.slice(0, 20).map((experienceItem) => {
            const { spaceKeyword, standardKeyword } = experienceItem;
            // underscoreToHyphen
            const hyphenSpaceWord = spaceKeyword.replace(/_/g, '-');
            const displayedKeyword = standardKeyword.replace(/_/g, ' ');
            return (
              <li>
                <a
                  key={`related-experience-item-${hyphenSpaceWord}`}
                  className="related-experience-item"
                  href={`/experience/${hyphenSpaceWord}?region=${articleRegion}`}
                >
                  <strong>{displayedKeyword}</strong>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    )
  );
};
